<template>
  <div class="px-20">
    <vs-popup
      class="custom-popup editPromo-popup"
      classContent="popup-example"
      :title="`${formData['actionName']} Tucows Promo`"
      :active.sync="editPromoRequestPopup">

      <div slot="header">Edit Tucows Promo</div>

      <div>
        <div class="static-box-header">
          <div class="header">TUCOWS PROMOS</div>
          <div class="form-actions">
            <vx-tooltip text="Copy any end date manually and click here to paste it to all entries" position="top">
              <vs-button
                class="iconOnly"
                color="dark"
                type="flat"
                icon-pack="feather"
                icon="icon-copy"
                @click="copyEndDate">
              </vs-button>
            </vx-tooltip>
          </div>
        </div>
        
        <div class="tucowsPromo-editForm table-form pr-4 pl-4">
          <ul class="table-head">
            <li class="theading">Client Name</li>
            <li class="theading">Promo Name</li>
            <li class="theading">TLD</li>
            <li class="theading">Tucows Name(s)</li>
            <li class="theading">Type</li>
            <li class="theading">Premium</li>
            <li class="theading">Premium Tier</li>
            <li class="theading">Effective</li>
            <li class="theading">Start Date</li>
            <li class="theading">End Date</li>
            <li class="theading">Start Time</li>
            <li class="theading">End Time</li>
            <li class="theading">Comments</li>
          </ul>
          <div v-for="(tucows, counter) in tucowsPromo" v-bind:key="counter">
            <ul class="tucowsPromo-repeater table-body p1">
              <li>
                <v-select
                  class="w-full"
                  v-validate="formData['tucowsRequired']"
                  :name="`tucowsRegName-${counter}`"
                  data-vv-validate-on="blur"
                  :disabled="true"
                  v-model="tucows.reg_id"
                  :options="formRegs"
                  :clearable="false"
                  :multiple="false"
                  :closeOnSelect="true">
                </v-select>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has(`tucowsTLD-${counter}`)">
                  Required field
                </span>
              </li>
              <li>
                <div class="table-form-component">
                  <vs-input
                    class="w-full promoname"
                    v-validate="formData['tucowsRequired']"
                    name="Promo name"
                    data-vv-validate-on="blur"
                    v-model="tucows.promo_name"
                    :disabled="flags['disableInput']"/>
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('Promo name')">
                    Required field
                  </span>
                </div>
              </li>
              <li>
                <div class="table-form-component">
                  <v-select
                    class="w-full"
                    v-validate="formData['tucowsRequired']"
                    :name="`tucowsTLD-${counter}`"
                    data-vv-validate-on="blur"
                    v-model="tucows.tld_id"
                    :options="formTlds"
                    :clearable="false"
                    :multiple="false"
                    :closeOnSelect="true"
                    :disabled="flags['disableInput']"
                    @option:selected="clearSelectedTucowsIDs(counter)"
                    @option:deselected="clearSelectedTucowsIDs(counter)"
                    @input="fetchPremiumTiers(counter)">
                  </v-select>
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has(`tucowsTLD-${counter}`)">
                    Required field
                  </span>
                </div>
              </li>
              <li>
                <div class="table-form-component">
                  <vs-input
                    class="w-full tucowsNames"
                    v-validate="formData['tucowsRequired']"
                    name="Tucows Names"
                    data-vv-validate-on="blur"
                    v-model="tucows.tucows_names"
                    :disabled="true"/>
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('Tucows Names')">
                    Required field
                  </span>
                </div>
              </li>
              <li style="width: 210px;">
                <div class="table-form-component">
                  <v-select
                    class="w-full"
                    v-validate="formData['tucowsRequired']"
                    :name="`tucowsType-${counter}`"
                    data-vv-validate-on="blur"
                    v-model="tucows.type_of_reg"
                    :options="formInit['type_of_reg']"
                    :clearable="false"
                    :disabled="flags['disableInput']"
                  ></v-select>
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has(`tucowsType-${counter}`)">Required field</span>
                </div>
              </li>
              <li>
                <div class="table-form-component">
                  <v-select
                    class="w-full"
                    v-validate="formData['tucowsRequired']"
                    :name="`tucowsPremium-${counter}`"
                    data-vv-validate-on="blur"
                    v-model="tucows.premium"
                    :options="formInit['premium']"
                    :clearable="false"
                    :disabled="flags['disableInput']"
                    @input="fetchPremiumTiers(counter)">
                  </v-select>
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has(`tucowsPremium-${counter}`)">
                    Required field
                  </span>
                </div>
              </li>
              <li>
                <div class="table-form-component">
                  <v-select
                    class="w-full"
                    v-validate="tucows.premium.value ? formData['tucowsRequired'] : ''"
                    :name="`tucowsPremiumTier-${counter}`"
                    v-model="tucows.premiumTier"
                    :options="formInit.premiumTiersList[counter]"
                    :clearable="false"
                    :disabled="flags['disableInput'] || !tucows.premium.value">
                  </v-select>
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has(`tucowsPremiumTier-${counter}`)">
                    Required field
                  </span>
                </div>
              </li>
              <li>
                <div class="table-form-component">
                  <div v-if="!tucows.premium.value" class="w-full inputPrefix">
                    <vs-input
                      class="w-full"
                      v-validate="formData['tucowsRequired']"
                      :name="`Effective Promo Price-${counter}`"
                      data-vv-validate-on="blur"
                      v-model="tucows.effective_price_amt"
                      :key="`amt-input-${counter}`"
                      :disabled="flags['disableInput']"/>
                    <span class="currency-sign">$</span>
                    <span
                      class="text-danger text-sm"
                      v-if="errors.has('Effective Promo Price-' + counter)">
                      {{
                        errors
                          .first("Effective Promo Price-" + counter)
                          .replace("The Effective Promo Price-" + counter, "This")
                      }}
                    </span>
                  </div>
                  <div v-else class="w-full inputPrefix">
                    <vs-input
                      class="w-full"
                      v-validate="'required'"
                      :name="`Percentage Discount-${counter}`"
                      data-vv-validate-on="blur"
                      v-model="tucows.effective_price_per"
                      :key="`per-input-${counter}`"
                      :disabled="flags['disableInput']"/>
                    <span class="currency-sign">%</span>
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('Percentage Discount-' + counter)"
                      >{{ errors.first("Percentage Discount") }}</span>
                  </div>
                </div>
              </li>
              <li>
                <div class="table-form-component">
                  <flat-pickr
                    class="w-full"
                    v-validate="formData['tucowsRequired']"
                    :name="`tucows Start date-${counter}`"
                    data-vv-validate-on="blur"
                    :config="tucows.configFromdateTimePicker"
                    v-model="tucows.start_date"
                    placeholder="YYYY-MM-DD"
                    @on-change="onFromChangeTucows($event, counter)"
                    :disabled="flags['disableInput']"/>
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('tucows Start date-' + counter)">Required field</span>
                </div>
              </li>
              <li>
                <div class="table-form-component">
                  <div class="flex">
                    <flat-pickr
                      class="w-full"
                      v-validate="formData['tucowsRequired']"
                      :name="`tucows End date-${counter}`"
                      data-vv-validate-on="blur"
                      :config="tucows.configTodateTimePicker"
                      v-model="tucows.end_date"
                      placeholder="YYYY-MM-DD"
                      @on-change="onToChangeTucows($event, counter)"/>
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('tucows End date-' + counter)"
                      >Required field</span>
                  </div>
                </div>
              </li>
              <li>
                <div class="table-form-component">
                  <flat-pickr
                    class="w-full"
                    :config="configdateTimePicker"
                    v-model="tucows.start_time"
                    :disabled="flags['disableInput']"/>
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('startTime')">Required field</span>
                </div>
              </li>
              <li>
                <div class="table-form-component">
                  <flat-pickr
                    class="w-full"
                    :config="configdateEndTimePicker"
                    v-model="tucows.end_time"/>
                  <span class="text-danger text-sm" v-show="errors.has('endTime')">Required field</span>
                </div>
              </li>
              <li>
                <div class="table-form-component">
                  <vs-input
                    class="w-full"
                    :name="`Comments-${counter}`"
                    data-vv-validate-on="blur"
                    v-model="tucows.comments"
                    :key="`comments-${counter}`"
                  >
                  </vs-input>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="flex justify-end pb-4 pr-4 pt-2">
        <vs-button
          v-show="!flags['disableInput'] && !flags['duplicatebtn']"
          color="primary"
          type="filled"
          class="action-btn"
          @click="onSubmit()"
          >Save</vs-button
        >
        <vs-button
          v-show="flags['disableInput'] && !flags['duplicatebtn']"
          color="primary"
          type="filled"
          class="action-btn"
          @click="onEditSubmit()"
          >Save</vs-button
        >
        <vs-button
          v-show="flags['duplicatebtn']"
          color="primary"
          type="filled"
          class="action-btn"
          @click="onDuplicateSubmit()"
          >Save</vs-button
        >
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  name: "EditTucowsPromo",
  components: {
    "v-select": vSelect,
    flatPickr,
  },
  data() {
    return {
      editReq: false,
      promoNameSpan: [],
      configdateTimePicker: {
        time_24hr: true,
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i:S",
        enableSeconds: true,
        defaultDate: "00:00:00",
        allowInput: true,
      },
      configdateEndTimePicker: {
        time_24hr: true,
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i:S",
        enableSeconds: true,
        defaultDate: "23:59:59",
        allowInput: true,
      },
      tucowsPromo: [
        {
          id: "",
          reg_id: [],
          promo_name: "",
          tld_id: "",
          effective_price_amt: "",
          effective_price_per: "",
          price_type: [{ label: "$", value: "$" }],
          premium: { label: "No", value: 0 },
          premiumTier: { label: "NA", value: "null" },
          group_id: null,
          type_of_reg: "",
          start_date: null,
          end_date: null,
          start_time: "",
          end_time: "",
          status: "",
          comments: "",
          configFromdateTimePicker: {
            minDate: new Date(),
            maxDate: null,
          },
          configTodateTimePicker: {
            minDate: null,
            allowInput: true
          },
          selectedGroup: "",
          selectedClient: ""
        },
      ],
      formData: {
        actionName:'',
        selectedPromoName: {
          selectedGroup: "",
          selectedTLD: "",
          selectedClient: "",
          selectedType: "",
          selectedPrem: "",
          selectedMonthYear: "",
          selectedClientId: "",
          selectedCountryId: "",
        },
        promo_name_new: "",
        status: "approval pending",
        displayTimezone: "(UTC)",
        tucowsRequired: "required",
      },
      formInit: {
        reg_ids: [],
        tld_ids: [],
        type_of_reg: ["Create", "Renew"],
        premium: [
          {
            label: "Yes",
            value: true,
          },
          {
            label: "No",
            value: false,
          },
        ],
        premiumTiersList: [],
      },
      extended: false,
      flags: {
        disableInput: false,
        duplicatebtn: false,
      },
      editPromoRequestPopup: false,
      PromoNamePartRecommendation: [],
      configFromdateTimePicker: {
        // minDate: new Date(),
        maxDate: null,
        wrap: true,
      },
      configTodateTimePicker: {
        minDate: null,
        wrap: true,
        allowInput: true
      },
    };
  },
  watch: {
    tucowsPromo: {
      deep: true,
      handler() {
        this.promoNameFormations();
      },
    },

    editPromoRequestPopup(val) {
      if (!val) {
        this.errors.clear();
        setTimeout(() => {
          this.flags["duplicatebtn"] = false;
          this.flags["disableInput"] = false;
        }, 10);
      }
    },

    // NOTE: Vuex master data getters(helpers)
    formResellers() {
      return this.$store.getters.formResellers;
    },
    formRegs() {
      return this.$store.getters.formRegs;
    },
    formGeo() {
      return this.$store.getters.formGeo;
    },
    formTlds() {
      return this.$store.getters.formTlds;
    },
    formPromoTags() {
      return this.$store.getters.formPromoTags;
    },
    formCustomTags() {
      return this.$store.getters.formCustomTags;
    },
  },
  computed: {
    user_id() {
      return JSON.parse(localStorage.getItem("userDetails")).id;
    },

    user_role() {
      return JSON.parse(localStorage.getItem("userDetails")).role;
    },

    // NOTE: Vuex master data getters(helpers)
    formResellers() {
      return this.$store.getters.formResellers;
    },
    formRegs() {
      return this.$store.getters.formRegs;
    },
    formGeo() {
      return this.$store.getters.formGeo;
    },
    formTlds() {
      return this.$store.getters.formTlds;
    },
    formPromoTags() {
      return this.$store.getters.formPromoTags;
    },
    formCustomTags() {
      return this.$store.getters.formCustomTags;
    },

    promoTld: function () {
      return this.LocalTldValue;
    }
  },
  mounted() {
    this.$root.$on("selectedGroupEditTucows", (nodeData, extended, editReq) => {
      if(extended) {
        this.extended = true;
      }

      if(editReq) {
        this.editReq = true;
      }

      this.formatGroupEditData(nodeData);
      this.editPromoRequestPopup = true;
      this.formData['actionName'] = 'Edit';
    });

    this.$root.$on("duplicatePromoTucows", (nodeData) => {
      this.formatSingleDuplicateData(nodeData);
      this.formData['actionName'] = 'Duplicate';
      this.editPromoRequestPopup = true;
      this.flags["duplicatebtn"] = true;
    });
  },
  beforeMount() {},
  methods: {
    openLoadingInDiv() {
      this.$vs.loading({
        container: "#div-with-loading",
        scale: 0.8,
      });
    },

    hideLoadingInDiv() {
      this.$vs.loading.close("#div-with-loading > .con-vs-loading");
    },

    onFromChangeTucows(event, counter) {
      this.$set(
        this.tucowsPromo[counter].configTodateTimePicker,
        "minDate",
        event[0]
      );
    },

    onToChangeTucows(event, counter) {
      this.$set(
        this.tucowsPromo[counter].configFromdateTimePicker,
        "maxDate",
        event[0]
      );
    },

    clearSelectedTucowsIDs(index) {
      this.tucowsPromo[index]["selectedTucowsNames"] = "";
      this.tucowsPromo[index]["selectTucowsNames"] = {};
      this.tucowsPromo[index]["tempSelectTucowsNames"] = {};

      // NOTE: Fetch Premium Tiers
      // this.fetchPremiumTiers(index);
    },

    formatGroupEditData(selectedRowData) {
      this.tucowsPromo.splice(0);

      var rowData = selectedRowData.map((x) => x.data);
      var approvedCheck = rowData.map((x) => x.approved_by);

      if (approvedCheck.some(x => x)) {
        this.flags["disableInput"] = true;
      } else {
        this.flags["disableInput"] = false;
      }

      var getRegistrar, getGroup, getTld, getPremium, getStartDates, getTucowsNames;

      getRegistrar = rowData.map((x) => {
        return {
          label: x.tucows_registrar.unique_registrar.name,
          countryId: x.tucows_registrar.unique_registrar.country_id,
          value: x.tucows_registrar.id,
        };
      });

      getGroup = rowData.map((x) => {
        return {
          id: x.group ? x.group.id : null,
          name: x.group ? x.group.name : null,
        };
      });

      getTld = rowData.map((x) => {
        return {
          label: x.tld.tld_name,
          name: x.tld.tld_name,
          value: x.tld.id,
        };
      });

      getPremium = rowData.map((x) => {
        if (x.premium === 0) {
          return {
            label: "No",
            value: false,
          };
        } else {
          return {
            label: "Yes",
            value: true,
          };
        }
      });

      getTucowsNames = rowData.map((x) => {
        return x.tucows_registrar.name;
      });

      var currentDateWithFormat = new Date()
        .toJSON()
        .slice(0, 10)
        .replace(/-/g, "-");

      getStartDates = rowData.map((x) => {
        if (currentDateWithFormat > x.start_date) {
          return {
            start_date: x.start_date,
            configPastFromdateTimePicker: x.start_date,
          };
        } else {
          return {
            start_date: x.start_date,
            configPastFromdateTimePicker: null,
          };
        }
      });

      for (var index = 0; index < rowData.length; index++) {
        this.tucowsPromo.push({
          id: rowData.map((x) => x.id)[index],
          tucows_promo_id: rowData.map((x) => x.tucows_promo_id)[index],
          reg_id: getRegistrar[index],
          tld_id: getTld[index],
          tucows_names: getTucowsNames[index],
          effective_price_amt: rowData.map((x) => x.target_price)[index],
          effective_price_per: rowData.map((x) => x.discount)[index],
          premium: getPremium[index],
          premiumTier: rowData.map((x) => {
            return x.tucows_premium_tier_id;
          })[index],
          all_premium_tiers: rowData.map((x) => x.all_premium_tiers)[index],
          type_of_reg: rowData.map((x) => this.toTitleCase(x.types[0]))[index],
          group_id: rowData.map((x) => x.group_id)[index],
          start_date: getStartDates[index]["start_date"],
          end_date: rowData.map((x) => x.end_date)[index],
          start_time: rowData.map((x) => x.start_time)[index],
          end_time: rowData.map((x) => x.end_time)[index],
          promo_name: rowData.map((x) => x.promo_name)[index],
          status: rowData.map((x) => x.status)[index],
          comments: rowData.map((x) => x.comments)[index],
          configFromdateTimePicker: {
            minDate: getStartDates[index]["configPastFromdateTimePicker"],
            maxDate: null,
          },
          configTodateTimePicker: {
            minDate: null,
            allowInput: true
          },
          selectedGroup: getGroup[index].id
            ? getGroup[index].name.split(" ").join("-")
            : "",
          selectedClient: getRegistrar[index].label.split(" ").join("-"),
        });

        this.fetchPremiumTiers(index);
      }
    },

    formatSingleDuplicateData(selectedRowData) {
      this.tucowsPromo.splice(0);

      var rowData = selectedRowData.map((x) => x.data);

      var getRegistrar, getGroup, getTld, getPremium, getStartDates, getAgreements, getTucowsNames;

      getRegistrar = rowData.map((x) => {
        return {
          label: x.tucows_registrar.unique_registrar.name,
          countryId: x.tucows_registrar.unique_registrar.country_id,
          value: x.tucows_registrar.id,
        };
      });

      getGroup = rowData.map((x) => {
        return {
          id: x.group ? x.group.id : null,
          name: x.group ? x.group.name : null,
        };
      });

      getTld = rowData.map((x) => {
        return {
          label: x.tld.tld_name,
          name: x.tld.tld_name,
          value: x.tld.id,
        };
      });

      getPremium = rowData.map((x) => {
        if (x.premium === 0) {
          return {
            label: "No",
            value: false,
          };
        } else {
          return {
            label: "Yes",
            value: true,
          };
        }
      });

      getTucowsNames = rowData.map((x) => {
        return x.tucows_registrar.name;
      });

      var currentDateWithFormat = new Date()
        .toJSON()
        .slice(0, 10)
        .replace(/-/g, "-");


      getStartDates = rowData.map((x) => {
        if (currentDateWithFormat > x.start_date) {
          return {
            start_date: x.start_date,
            configPastFromdateTimePicker: currentDateWithFormat,
          };
        } else {
          return {
            start_date: x.start_date,
            configPastFromdateTimePicker: currentDateWithFormat,
          };
        }
      });

      getAgreements = rowData[0].dropbox_detail.map(x => x.id);

      for (var index = 0; index < rowData.length; index++) {

        this.tucowsPromo.push({
          id: rowData.map((x) => x.id)[index],
          reg_id: getRegistrar[index],
          tld_id: getTld[index],
          tucows_names: getTucowsNames[index],
          effective_price_amt: rowData.map((x) => x.target_price)[index],
          effective_price_per: rowData.map((x) => x.discount)[index],
          premium: getPremium[index],
          premiumTier: rowData.map((x) => {
            return x.tucows_premium_tier_id;
          })[index],
          type_of_reg: rowData.map((x) => this.toTitleCase(x.types[0]))[index],
          group_id: rowData.map((x) => x.group_id)[index],
          start_date: null,
          end_date: null,
          start_time: rowData.map((x) => x.start_time)[index],
          end_time: rowData.map((x) => x.end_time)[index],
          promo_name: rowData.map((x) => x.promo_name)[index],
          status: rowData.map((x) => x.status)[index],
          comments: rowData.map((x) => x.comments)[index],
          configFromdateTimePicker: {
            minDate: getStartDates[index]["configPastFromdateTimePicker"],
            maxDate: null,
          },
          configTodateTimePicker: {
            minDate: null,
            allowInput: true
          },
          selectedGroup: getGroup[index].id
            ? getGroup[index].name.split(" ").join("-")
            : "",
          selectedClient: getRegistrar[index].label.split(" ").join("-"),
          general_agreements: getAgreements,
          unique_registrar_id: rowData[0].tucows_registrar.unique_registrar_id
        });

        this.fetchPremiumTiers(index);
      }
    },

    onSubmit() {
      var tucowsPriceObject = {
        amtNum: [],
        perNum: [],
      };

      this.tucowsPromo.forEach((x) => {
        if (x.premium.value == 0) {
          tucowsPriceObject["amtNum"].push(
            (Math.round(x.effective_price_amt * 100) / 100).toFixed(2)
          );
          tucowsPriceObject["perNum"].push(0);
        } else {
          tucowsPriceObject["amtNum"].push(0);
          tucowsPriceObject["perNum"].push(
            (Math.round(x.effective_price_per * 100) / 100).toFixed(2)
          );
        }
      });

      var tucowsPromoData = {};

      tucowsPromoData = this.tucowsPromo.map((x, index) => {
        return {
          id: x.id,
          name: x.promo_name,
          start_date: x.start_date,
          end_date: x.end_date,
          start_time: x.start_time,
          end_time: x.end_time,
          types: [x.type_of_reg.toLowerCase()],
          discount_type: !x.premium.value ? "targetPrice" : "percentage",
          discount: tucowsPriceObject["perNum"][index],
          target_price: tucowsPriceObject["amtNum"][index],
          tucows_registrar_id: x.reg_id.value,
          tld_id: x.tld_id.value,
          premium: x.premium.value,
          tucows_premium_tier_id: x.premium.value ? x.premiumTier.value : null,
          all_premium_tiers: x.premiumTier.value == 'all' ? true : false,
          periods: [1],
          status: "approval pending",
          comments: x.comments,
        };
      });

      this.$validator.validateAll().then((result) => {
        if (result) {
          //Loader
          this.openLoadingInDiv();

          this.$axiosSecure
            .post("/tucows/promos/requests/edit", tucowsPromoData)
            .then((response) => {
              this.hideLoadingInDiv();
              this.resetFields();
              this.tableRefresh();

              setTimeout(() => {
                // Confimation notification
                this.$vs.dialog({
                  color: "success",
                  title: "Tucows Promo edited",
                  text: "Selected Tucows Promo(s) have been successfully edited.",
                  acceptText: "Close",
                });
                this.editPromoRequestPopup = false;
              }, 100);
            })
            .catch((error) => {
              console.log(error);
              // Hide loader
              this.hideLoadingInDiv();
              setTimeout(() => {
                if (error.response.data && error.response.data.message) {
                  this.errorMessage = error.response.data.message;
                } else if(error.response.data.type == "Error" && error.response.data.data && error.response.data.data.length) {
                  this.tucowsPromo = this.tucowsPromo.filter(x => error.response.data.data.includes(x.id));
                  this.errorMessage = error.response.data.message;
                } else {
                  this.errorMessage = "Please contact the server admin.";
                }
                //Error msg
                this.$vs.dialog({
                  color: "danger",
                  title: "Error",
                  text: this.errorMessage,
                  acceptText: "Close",
                  accept: () => {},
                });
              }, 100);
            });
        } else {
          // form have errors
          console.error("The form has errors");
        }
      });
    },

    onEditSubmit() {
      var tucowsPromoData = {};

      tucowsPromoData = this.tucowsPromo.map((x, index) => {
        return {
          tucows_promo_id: x.id,
          end_date: x.end_date,
          end_time: x.end_time,
          status: "edit pending",
          comments: x.comments,
          extended: this.extended,
        };
      });

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.editPromoRequestPopup = false;
          //Loader
          this.openLoadingInDiv();

          this.$axiosSecure
            .post("/tucows/promos/edit", tucowsPromoData)
            .then((response) => {
              this.hideLoadingInDiv();
              this.resetFields();
              this.tableRefresh();

              setTimeout(() => {
                // Confimation notification
                this.$vs.dialog({
                  color: "success",
                  title: "Tucows Promo edited",
                  text: "Selected Tucows Promo(s) have been successfully edited.",
                  acceptText: "Close",
                });
              }, 100);
            })
            .catch((error) => {
              console.log(error);
              // Hide loader
              this.hideLoadingInDiv();

              setTimeout(() => {
                //Error msg
                if (error.response.data && error.response.data.message) {
                  this.errorMessage = error.response.data.message;
                } else {
                  this.errorMessage = "Please contact the server admin.";
                }
                //Error msg
                this.$vs.dialog({
                  color: "danger",
                  title: "Error",
                  text: this.errorMessage,
                  acceptText: "Close",
                  accept: () => {},
                });
              }, 100);
            });
        } else {
          // form have errors
          // console.log("form have errors");
        }
      });
    },

    onDuplicateSubmit() {
      var tucowsPriceObject = {
        amtNum: [],
        perNum: [],
      };

      this.tucowsPromo.forEach((x) => {
        if (x.premium.value == 0) {
          tucowsPriceObject["amtNum"].push(
            (Math.round(x.effective_price_amt * 100) / 100).toFixed(2)
          );
          tucowsPriceObject["perNum"].push(0);
        } else {
          tucowsPriceObject["amtNum"].push(0);
          tucowsPriceObject["perNum"].push(
            (Math.round(x.effective_price_per * 100) / 100).toFixed(2)
          );
        }
      });

      var tucowsPromoData = {};

      tucowsPromoData = this.tucowsPromo.map((x, index) => {
        return {
          name: [x.promo_name],
          start_date: x.start_date,
          end_date: x.end_date,
          start_time: x.start_time,
          end_time: x.end_time,
          types: [x.type_of_reg.toLowerCase()],
          discount_type: !x.premium.value ? "targetPrice" : "percentage",
          discount: tucowsPriceObject["perNum"][index],
          target_price: tucowsPriceObject["amtNum"][index],
          tucows_registrar_id: [this.tucowsPromo[0].reg_id.value],
          tld_id: [x.tld_id.value],
          premium: x.premium.value,
          all_premium_tiers: x.premiumTier.value == 'all' ? true : false,
          tucows_premium_tier_id: x.premium.value ? x.tucows_premium_tier_id : null,
          comments: x.comments,
          // NOTE: Hardcoded until feature is developed
          // is_sticky: false,
          // sticky_survives_transfer: false,
          // allow_multiuse: true,
          // per_transaction: true,
          // all_registrars: false,
          // periods: [1]

          is_sticky: false,
          sticky_survives_transfer: false,
          allow_multiuse: false,
          all_registrars: false,
          per_transaction: true,
          periods: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
        };
      });

      this.$validator.validateAll().then((result) => {
        // console.log("form");
        if (result) {
          // this.editPromoRequestPopup = false;
          //Loader
          this.openLoadingInDiv();
          // this.flags["isFormSubmitted"] = true;

          this.$axiosSecure
            .post("/tucows/promos/duplicate", {
            // .post("/tucows-promos-request/duplicate", {
              user_id: JSON.parse(localStorage.getItem("userDetails")).id,
              status: "approval pending",
              comments: this.tucowsPromo[0]["comments"],
              unique_registrar_id: this.tucowsPromo[0]["unique_registrar_id"],
              general_agreements: this.tucowsPromo[0].general_agreements,
              tucows: tucowsPromoData,
            })
            .then((response) => {
              this.hideLoadingInDiv();
              this.resetFields();
              this.tableRefresh();
              // console.log(response.data);
              setTimeout(() => {
                // Confimation notification
                this.$vs.dialog({
                  color: "success",
                  title: "Thank You",
                  text: "Tucows Promo has been successfully created.",
                  acceptText: "Close",
                  // accept: () => {
                  //   this.$router.push({ path: "/internal-promo-list" });
                  // }
                });
              }, 100);
              this.editPromoRequestPopup = false;
            })
            .catch((error) => {
              console.log(error);
              // Hide loader
              this.hideLoadingInDiv();
              //console.log(error.response.message);
              setTimeout(() => {
                //Error msg
                if (error.response.data && error.response.data.message) {
                  this.errorMessage = error.response.data.message;
                } else {
                  this.errorMessage = "Please contact the server admin.";
                }
                //Error msg
                this.$vs.dialog({
                  color: "danger",
                  title: "Error",
                  text: this.errorMessage,
                  acceptText: "Close",
                  accept: () => {},
                });
              }, 100);
              this.editPromoRequestPopup = false;
            });
        } else {
          // form have errors
          // console.log("form have errors");
        }
      });
    },

    resetFields() {
      (this.batchId = ""), (this.formData["reg_id"] = []);
      this.formData["selectedPromoName"]["selectedGroup"] = "";
      this.formData["selectedPromoName"]["selectedTLD"] = "";
      this.formData["selectedPromoName"]["selectedClient"] = "";
      this.formData["selectedPromoName"]["selectedType"] = "";
      this.formData["selectedPromoName"]["selectedPrem"] = "";
      this.formData["selectedPromoName"]["selectedMonthYear"] = "";
      this.formData["selectedPromoName"]["selectedClientId"] = "";
      this.formData["selectedPromoName"]["selectedCountryId"] = "";
      this.formData["promo_name_new"] = "";
      this.formData["status"] = "approval pending";
      this.formData["displayTimezone"] = "(UTC)";
      this.formData["tucowsRequired"] = "required";

      this.tucowsPromo.forEach((element) => {
        (element.checkBox = false),
          (element.promo_name = ""),
          (element.tld_id = []),
          (element.effective_price_amt = ""),
          (element.effective_price_per = ""),
          (element.price_type = [{ label: "$", value: "$" }]),
          (element.premium = { label: "No", value: false }),
          (element.type_of_reg = ""),
          (element.start_date = null),
          (element.end_date = null),
          (element.start_time = "00:00:00"),
          (element.end_time = "23:59:59"),
          (element.configFromdateTimePicker = {
            minDate: new Date(),
            maxDate: null,
          }),
          (element.configTodateTimePicker = {
            minDate: null,
            allowInput: true
          });
      });
      //Remove all the repetative form data and keep only one
      this.tucowsPromo.splice(1);
    },

    tableRefresh() {
      this.$root.$emit("tableRefresh");
    },

    // TODO: Fix the name staging duplicate prefix & why undefined appears
    promoNameFormations() {
      this.tucowsPromo.forEach((element) => {
        (this.PromoNamePartRecommendation = []), (this.promoNameSpan = []);

        if (element["reg_id"]) {
          element["selectedClient"] = element["reg_id"].label
            .split(" ")
            .join("-");
        }

        const prefix = process.env.VUE_APP_PREFIX_ENV == "production" ? "" : "staging.";

        let selectedTld,
            selectedType,
            selectedPremiumAndTier,
            selectedMonthYear,
            promoNameArray = [];

        if (element["tld_id"]) {
          this.tldValue = [
            {
              label: element["tld_id"].label,
              value: element["tld_id"].value,
            },
          ];

          const tldString = this.tldValue
            .map((x) => x.label)
            .toString()
            .split(".");
          const tldStringJoin = tldString.join("-");

          selectedTld = tldStringJoin;
        }

        if (element["type_of_reg"] == "Create") {
          selectedType = "create";
        } else if (element["type_of_reg"] == "Renew") {
          selectedType = "renew";
        } else {
          selectedType = "";
        }

        if (element["premium"].value == 1) {
          selectedPremiumAndTier = `prem-${element["premiumTier"] ? element["premiumTier"].label.toLowerCase().split(' ').join('-') : '' }`;
        } else {
          selectedPremiumAndTier = "";
        }

        if (element["start_date"]) {
          var startDate = this.$moment(element["start_date"]);
          var monYear = startDate.format("MMM") + "." + startDate.format("YY");
          selectedMonthYear = monYear;
        }

        this.formData["promo_name_new"] = `${
          selectedTld != "" && selectedTld != undefined ? "." + selectedTld : ""
        }${
          selectedType != "" && selectedType != undefined
            ? "." + selectedType
            : ""
        }${
          selectedPremiumAndTier != "" && selectedPremiumAndTier != undefined
            ? "." + selectedPremiumAndTier
            : ""
        }${
          selectedMonthYear != "" && selectedMonthYear != undefined
            ? "." + selectedMonthYear
            : ""
        }`;

        const name = this.formData["promo_name_new"];
        const nameArray = name.split(".");
        const nameString = nameArray.slice(0).join(".");
        
        promoNameArray.push({
          name: `${prefix}${element['tucows_names']}${nameString}`,
        });

        this.PromoNamePartRecommendation.push(promoNameArray);
        this.promoNameSpan = [
          ...this.promoNameSpan,
          ...promoNameArray.map((x) => x.name),
        ];
        
        element["promo_name"] = this.promoNameSpan.toString();
      });
    },

    copyEndDate() {
      navigator.clipboard.readText().then(
          (textCopied) => {
            this.tucowsPromo.map(x => {
              x.end_date = textCopied.toString();
            })
          },
          (err) => {
              console.error('Could not paste text: ', err)
          }
      );
    },

    fetchPremiumTiers(index) {
      if(this.tucowsPromo[index]["tld_id"].value) {
        if(this.tucowsPromo[index]["premium"].value == false) {
          this.tucowsPromo[index]["premiumTier"] = { label: "NA", value: null };
          this.formInit["premiumTiersList"][index] = [];
          return;
        } else {
          this.$axiosSecure
          .get("/tucows/premium-tiers/" + this.tucowsPromo[index]["tld_id"].value)
          .then((response) => {
            this.$set(this.formInit["premiumTiersList"], index, response.data.map((x) => {
              return {
                label: x.tier_name,
                value: x.id,
              };
            }));
            this.formInit["premiumTiersList"][index].unshift({
              label: "All Tiers",
              value: 'all',
            })

            if(this.tucowsPromo[index]["all_premium_tiers"]) {
              this.tucowsPromo[index]["premiumTier"] = this.formInit["premiumTiersList"][index].find(x => x.value === 'all') || null;
            } else {
              this.tucowsPromo[index]["premiumTier"] = this.formInit["premiumTiersList"][index].find(x => x.value === this.tucowsPromo[index]["premiumTier"]) || null;
            }

          })
          .catch((error) => {
            this.customPromptError = error.response.data.data;
            this.customPrompt["classList"] = "danger-prompt";
            this.customPrompt["color"] = "danger";
            this.customPrompt["activePrompt"] = true;
          });
        }
      } else {
          this.tucowsPromo[index]["premiumTier"] = { label: "NA", value: null };
          this.formInit["premiumTiersList"][index] = [];
        }
    }
  },
};
</script>